"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledApptDetails = exports.StyledProviderLocation = exports.ProviderSpecialities = exports.ProviderTitle = exports.ProviderTitleSpecialtiesContainer = exports.ProviderImg = exports.Row = exports.StyledTime = exports.StyledSubHeading = exports.StyledProviderCardContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const image_component_1 = __importDefault(require("@kyruus/image-component"));
exports.StyledProviderCardContainer = styled_1.default.section `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  align-self: stretch;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
  line-height: 21px;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StyledSubHeading = styled_1.default.h5 `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  margin: 0px 0px ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0px;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.StyledTime = styled_1.default.p `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0px ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px;
  > span > span {
    color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  }
`;
exports.Row = styled_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 12px;
`;
exports.ProviderImg = (0, styled_1.default)(image_component_1.default) `
  width: ${({ enhancementEnabled }) => (enhancementEnabled ? 'unset' : '40px')};
  height: ${({ enhancementEnabled }) => enhancementEnabled ? 'unset' : '40px'};
  border-radius: ${(0, ui_theme_1.fromTheme)('dbw_provider_image_border_radius')};
`;
exports.ProviderTitleSpecialtiesContainer = styled_1.default.div ``;
exports.ProviderTitle = styled_1.default.div `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.ProviderSpecialities = styled_1.default.div ``;
exports.StyledProviderLocation = styled_1.default.div `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  > p {
    margin: 0px;
  }
`;
exports.StyledApptDetails = styled_1.default.p `
  margin: 0px;
`;
//# sourceMappingURL=style.js.map